import { keyBy } from "@aprao/common/src/array/keyBy.js";

export const lengthUnits = [
  {
    code: "foot",
    symbol: "ft",
    name: "Feet",
  },
  {
    code: "meter",
    symbol: "m",
    name: "Meters",
  },
] as const;

export const lengthUnitsByCodes = keyBy(lengthUnits, "code");
